import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useLocation } from "react-router-dom";
import AddEditPTOView from "./AddEditPTOView";
import {
  SET_EMPTY,
  CLOCK_OUT,
  DEVICE_DETAILS,
  CONFIRMATION,
  PTO,
  NON_TRANSACTIONAL,
} from "../../../../config";

import { getPunch, getUniqueID } from "../../../../utils/punch";

import { ACTIVITIES, ALL_ACTIVITIES, REPORTS, REVIEW } from "../../../../navigation/CONSTANTS";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  ZERO,
  NEGATIVE,
  EQUAL,
  OVERLAPPING,
  POSITIVE,
  DAY24HRS,
  ADD,
  UPDATE,
  categoryPTO,
} from "pages/Punch/constants";
//backend
import {
  addPunch,
  updatePunch,
  getPunchData,
  getNewWorkerPunchRecords,
  setLastPunch,
} from "../../../../services";

import { isEmptyObject, isDateValid ,properCase} from "../../../../utils/index";
import { dateConfig, EDIT_STATUS, NEW_STATUS } from "../../../../config/index";
import { EMPTY } from "pages/AddWorker/config";

const minForStartDate = moment().day(-15).toDate();
const maxDate = moment().day(20).toDate();

export const AddEditPTOContainer = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const loggedInSupervisor = user.auth.user.workerId;
  const [worker, setWorker] = useState(location.state.worker);
  const lastPunchIdVal =
    location.state.worker && location.state.worker.lastPunchId;
  const [lastPunchId, setLastPunchId] = useState(lastPunchIdVal);
  const currentPunch = location.state.punch;
  const defaultEmployee = [
    {
      workerId: -1,
      firstName: t("general.selectEmployee"),
      lastName: "",
    },
  ];
  const workers =
    location.state.workers && defaultEmployee.concat(location.state.workers);
  const [lastPunchDetails, setLastPunchDetails] = useState(null);
  const [pageTitle, setPageTitle] = useState(EMPTY);
  const [activityStartDate, setActivityStartDate] = useState(new Date());
  const [activityStartTime, setActivityStartTime] = useState(new Date());
  const [activityEndDate, setActivityEndDate] = useState(new Date());
  const [activityEndTime, setActivityEndTime] = useState(new Date());
  const [confirmationMsg, setConfirmationMsg] = useState(false);
  const [confirmationMsgText, setConfirmationMsgText] = useState(SET_EMPTY);

  const [disableSave, setDisableSave] = useState(false);

  const [confirmationTitleText, setConfirmationTitleText] = useState(
    CONFIRMATION
  );
  const [allowNavigation, setAllowNavigation] = useState(true);

  const activityStartDateChange = (date) => {
    setActivityStartDate(date);
    setActivityEndDate(date);
  };

  const activityStartTimeChange = (date) => {
    setActivityStartTime(date);
  };

  const activityEndDateChange = (date) => {
    setActivityEndDate(date);
  };

  const activityEndTimeChange = (date) => {
    setActivityEndTime(date);
  };

  const employeeChange = (event, newValue) => {
    setWorker(newValue);
    if (newValue.lastPunchId) {
      setLastPunchId(newValue.lastPunchId);
    }
  };

  const saveHandler = () => {
    setDisableSave(true);
    const actionBy = loggedInSupervisor;
    const inTS = new Date(
      activityStartDate.getFullYear(),
      activityStartDate.getMonth(),
      activityStartDate.getDate(),
      activityStartTime.getHours(),
      activityStartTime.getMinutes(),
      activityStartTime.getSeconds(),
      activityStartTime.getMilliseconds()
    ).toISOString();

    const _inLocalTS = new Date(
      activityStartDate.getFullYear(),
      activityStartDate.getMonth(),
      activityStartDate.getDate(),
      activityStartTime.getHours(),
      activityStartTime.getMinutes(),
      activityStartTime.getSeconds(),
      activityStartTime.getMilliseconds()
    ).toString();

    const inLocalTS = moment(_inLocalTS).format(dateConfig.format4);

    const outTS = new Date(
      activityEndDate.getFullYear(),
      activityEndDate.getMonth(),
      activityEndDate.getDate(),
      activityEndTime.getHours(),
      activityEndTime.getMinutes(),
      activityEndTime.getSeconds(),
      activityEndTime.getMilliseconds()
    ).toISOString();

    const _outLocalTS = new Date(
      activityEndDate.getFullYear(),
      activityEndDate.getMonth(),
      activityEndDate.getDate(),
      activityEndTime.getHours(),
      activityEndTime.getMinutes(),
      activityEndTime.getSeconds(),
      activityEndTime.getMilliseconds()
    ).toString();

    const outLocalTS = moment(_outLocalTS).format(dateConfig.format4);
    const actionTS = new Date().toISOString();
    const version = getUniqueID();

    let activityName = CLOCK_OUT;
    let isException = false;
    let exceptionName = SET_EMPTY;

    if (isEmptyObject(currentPunch)) {
      // add new punch
      const status = NEW_STATUS;
      const newPunch = getPunch(
        NON_TRANSACTIONAL,
        activityName,
        lastPunchDetails && lastPunchDetails.buildingId
          ? lastPunchDetails.buildingId
          : "",
        lastPunchDetails && lastPunchDetails.districtId
          ? lastPunchDetails.districtId
          : "",
        lastPunchDetails && lastPunchDetails.customerSite
          ? lastPunchDetails.customerSite
          : "",
        exceptionName,
        isException,
        PTO,
        lastPunchDetails && lastPunchDetails.jobProjectInfo
          ? lastPunchDetails.jobProjectInfo
          : "",
        status,
        version,
        worker.workerId,
        actionTS,
        inTS,
        inLocalTS,
        outTS,
        outLocalTS,
        actionBy,
        DEVICE_DETAILS,
        categoryPTO
      );
      console.log("on save ", newPunch);
      let isPass = "";
      let action = "";
      const startdate = moment(newPunch.inLocalTS).format(dateConfig.format6);
      const endDate = moment(newPunch.outLocalTS).format(dateConfig.format6);
      const recentPunchIn = moment(newPunch.inLocalTS).format(
        dateConfig.format7
      );
      const recentPunchOut = moment(newPunch.outLocalTS).format(
        dateConfig.format7
      );
      const dayDiff = parseInt(
        moment
          .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
          .asMinutes()
      );
      console.log("recentPunchIn......." + recentPunchIn);
      console.log("recentPunchOut......." + recentPunchOut);
      console.log("DayDIff......." + dayDiff);
      getNewWorkerPunchRecords(
        newPunch.workerId,
        moment(startdate).subtract(1, "days").format(dateConfig.format4),
        moment(endDate).add(1, "days").format(dateConfig.format4)
      )
        .then((querySnapshot) => {
          console.log("querySnapshot....." + querySnapshot);
          if (querySnapshot != undefined && querySnapshot.length > 0) {
            querySnapshot.forEach((doc) => {
              if (doc.outLocalTS !== "") {
                doc.inLocalTS = moment(doc.inLocalTS).format(
                  dateConfig.format7
                );
                doc.outLocalTS = moment(doc.outLocalTS).format(
                  dateConfig.format7
                );
                if (recentPunchOut == recentPunchIn) {
                  isPass = ZERO;
                } else if (recentPunchOut < recentPunchIn) {
                  isPass = NEGATIVE;
                } else if (dayDiff >= 1440) {
                  isPass = DAY24HRS;
                } else if (
                  recentPunchIn == doc.inLocalTS &&
                  recentPunchOut == doc.outLocalTS
                ) {
                  isPass = EQUAL;
                } else if (
                  (doc.inLocalTS > recentPunchIn &&
                    doc.inLocalTS < recentPunchOut) ||
                  (doc.outLocalTS > recentPunchIn &&
                    doc.outLocalTS < recentPunchOut) ||
                  (recentPunchIn > doc.inLocalTS &&
                    recentPunchIn < doc.outLocalTS) ||
                  (recentPunchOut > doc.inLocalTS &&
                    recentPunchOut < doc.outLocalTS)
                ) {
                  isPass = OVERLAPPING;
                } else {
                  if (
                    isPass != NEGATIVE &&
                    isPass != ZERO &&
                    isPass != DAY24HRS &&
                    isPass != OVERLAPPING &&
                    isPass != EQUAL
                  ) {
                    isPass = POSITIVE;
                    action = ADD;
                  }
                }
              } else {
                doc.inLocalTS = moment(doc.inLocalTS).format(
                  dateConfig.format7
                );
                if (
                  recentPunchIn < doc.inLocalTS &&
                  recentPunchOut > doc.inLocalTS
                ) {
                  isPass = OVERLAPPING;
                } else if (recentPunchIn == doc.inLocalTS) {
                  isPass = EQUAL;
                } else {
                  if (isPass != OVERLAPPING && isPass != EQUAL) {
                    isPass = POSITIVE;
                    action = ADD;
                  }
                }
              }
            });
          } else {
            if (recentPunchOut == recentPunchIn) {
              isPass = ZERO;
            } else if (recentPunchOut < recentPunchIn) {
              isPass = NEGATIVE;
            } else if (dayDiff >= 1440) {
              isPass = DAY24HRS;
            } else {
              if (isPass != DAY24HRS && isPass != ZERO && isPass != NEGATIVE) {
                isPass = POSITIVE;
                action = ADD;
              }
            }
          }
          getValidateScenarios(isPass, action, newPunch, {});
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      // update punch
      const status = EDIT_STATUS;
      const newPunch = getPunch(
        NON_TRANSACTIONAL,
        activityName,
        currentPunch.buildingId,
        currentPunch.districtId,
        currentPunch.customerSite,
        exceptionName,
        isException,
        PTO,
        currentPunch.jobProjectInfo,
        status,
        version,
        worker.workerId,
        actionTS,
        inTS,
        inLocalTS,
        outTS,
        outLocalTS,
        actionBy,
        DEVICE_DETAILS,
        categoryPTO
      );
      console.log("on save ", newPunch);

      const startdate = moment(newPunch.inLocalTS).format(dateConfig.format6);
      const endDate = moment(newPunch.outLocalTS).format(dateConfig.format6);
      const recentPunchIn = moment(newPunch.inLocalTS).format(
        dateConfig.format7
      );
      const recentPunchOut = moment(newPunch.outLocalTS).format(
        dateConfig.format7
      );
      let isPass = "";
      let action = "";
      const dayDiff = parseInt(
        moment
          .duration(moment(recentPunchOut).diff(moment(recentPunchIn)))
          .asMinutes()
      );
      console.log("DayDIff......." + dayDiff);
      getNewWorkerPunchRecords(
        newPunch.workerId,
        moment(startdate).subtract(1, "days").format(dateConfig.format4),
        moment(endDate).add(1, "days").format(dateConfig.format4)
      )
        .then((querySnapshot) => {
          console.log("querySnapshot....." + querySnapshot);
          if (querySnapshot != undefined && querySnapshot.length > 0) {
            querySnapshot.forEach((doc) => {
              if (doc.outLocalTS !== "") {
                doc.inLocalTS = moment(doc.inLocalTS).format(
                  dateConfig.format7
                );
                doc.outLocalTS = moment(doc.outLocalTS).format(
                  dateConfig.format7
                );
                currentPunch.inLocalTS = moment(currentPunch.inLocalTS).format(
                  dateConfig.format7
                );
                currentPunch.outLocalTS = moment(
                  currentPunch.outLocalTS
                ).format(dateConfig.format7);
                if (recentPunchOut == recentPunchIn) {
                  isPass = ZERO;
                } else if (recentPunchOut < recentPunchIn) {
                  isPass = NEGATIVE;
                } else if (startdate !== endDate) {
                  isPass = DAY24HRS;
                } else if (
                  currentPunch.id !== doc.id &&
                  recentPunchIn == doc.inLocalTS &&
                  recentPunchOut == doc.outLocalTS
                ) {
                  isPass = EQUAL;
                } else if (
                  currentPunch.inLocalTS != doc.inLocalTS &&
                  currentPunch.outLocalTS != doc.outLocalTS
                ) {
                  if (
                    (doc.inLocalTS > recentPunchIn &&
                      doc.inLocalTS < recentPunchOut) ||
                    (doc.outLocalTS > recentPunchIn &&
                      doc.outLocalTS < recentPunchOut) ||
                    (recentPunchIn > doc.inLocalTS &&
                      recentPunchIn < doc.outLocalTS) ||
                    (recentPunchOut > doc.inLocalTS &&
                      recentPunchOut < doc.outLocalTS)
                  ) {
                    isPass = OVERLAPPING;
                  }
                } else {
                  if (
                    isPass != NEGATIVE &&
                    isPass != ZERO &&
                    isPass != DAY24HRS &&
                    isPass != EQUAL &&
                    isPass != OVERLAPPING
                  ) {
                    isPass = POSITIVE;
                    action = UPDATE;
                  }
                }
              } else {
                doc.inLocalTS = moment(doc.inLocalTS).format(
                  dateConfig.format7
                );
                if (recentPunchOut == recentPunchIn) {
                  isPass = ZERO;
                } else if (
                  recentPunchIn < doc.inLocalTS &&
                  recentPunchOut > doc.inLocalTS
                ) {
                  isPass = OVERLAPPING;
                } else if (recentPunchOut < recentPunchIn) {
                  isPass = NEGATIVE;
                } else if (startdate !== endDate) {
                  isPass = DAY24HRS;
                } else {
                  if (isPass != OVERLAPPING && isPass != EQUAL) {
                    isPass = POSITIVE;
                    action = UPDATE;
                  }
                }
              }
            });
          } else {
            if (recentPunchOut == recentPunchIn) {
              isPass = ZERO;
            } else if (recentPunchOut < recentPunchIn) {
              isPass = NEGATIVE;
            } else if (startdate !== endDate) {
              isPass = DAY24HRS;
            } else {
              if (isPass != DAY24HRS && isPass != ZERO && isPass != NEGATIVE) {
                isPass = POSITIVE;
                action = UPDATE;
              }
            }
          }
          getValidateScenarios(isPass, action, newPunch, currentPunch);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const getValidateScenarios = (isPass, action, newPunch, currentPunch) => {
    console.log("getValidationScenarios called ..........");
    switch (isPass) {
      case NEGATIVE:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgNegative"),
          t("other.tlError"),
          false
        );
        break;
      case ZERO:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgZero"),
          t("other.tlError"),
          false
        );
        break;
      case EQUAL:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgEqual"),
          t("other.tlError"),
          false
        );
        break;
      case DAY24HRS:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgPTODay24Hrs"),
          t("other.tlError"),
          false
        );
        break;
      case OVERLAPPING:
        setFlag(
          true,
          t("pgReview.dialogueMsgs.errMsgOverlapping"),
          t("other.tlError"),
          false
        );
        break;
      case POSITIVE:
        console.log("POsitive" + isPass);
        if (action == ADD) {
          addPunch(newPunch, true)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                CONFIRMATION,
                true
              );
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          updatePunch(currentPunch.id, newPunch)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                CONFIRMATION,
                true
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
        break;
      default:
        console.log("default" + isPass);
        if (action == ADD) {
          addPunch(newPunch, true)
            .then((result) => {
              console.log(result);
              setFlag(
                true,
                t("pgReview.dialogueMsgs.msgSuccess"),
                CONFIRMATION,
                true
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
        break;
    }
  };
  const setFlag = (msg, txt, titletxt, navigate) => {
    setConfirmationMsg(msg);
    setConfirmationMsgText(txt);
    setConfirmationTitleText(titletxt);
    setAllowNavigation(navigate);
  };
  const cancelHandler = () => {
    location.state.isAllPunch
      ? history.push(ALL_ACTIVITIES, { isAllPunchView: true })
      : location.state.isReport
        ? history.push(REPORTS, { isReportView: true })
        // : history.push(REVIEW);
        : history.push(ACTIVITIES);
  };

  const closeModalConfirmationMsg = () => {
    setConfirmationMsg(false);
    if (allowNavigation === true) {
      location.state.isAllPunch
        ? history.push(ALL_ACTIVITIES, { isAllPunchView: true })
        : location.state.isReport
          ? history.push(REPORTS, { isReportView: true })
          // : history.push(REVIEW);
          : history.push(ACTIVITIES);
    } else {
      setDisableSave(false);
    }
  };

  const back = () => {
    location.state.isAllPunch
      ? history.push(ALL_ACTIVITIES, { isAllPunchView: true })
      : location.state.isReport
        ? history.push(REPORTS, { isReportView: true })
        // : history.push(REVIEW);
        : history.push(ACTIVITIES);
  };

  // using currentPunch to populate UI fields
  useEffect(() => {
    if (!isEmptyObject(currentPunch)) {
      setPageTitle(properCase(t("pgAddEditPTOSupervisor.editPTO")));
      setActivityStartDate(new Date(currentPunch.inLocalTS));
      setActivityStartTime(new Date(currentPunch.inLocalTS));
      if (currentPunch.outLocalTS && currentPunch.outLocalTS !== SET_EMPTY) {
        setActivityEndDate(new Date(currentPunch.outLocalTS));
        setActivityEndTime(new Date(currentPunch.outLocalTS));
      }
    } else {
      setPageTitle(properCase(t("pgAddEditPTOSupervisor.addPTO")));
    }
    console.log("lastPunchId = ", lastPunchId);
    if (lastPunchId) {
      getPunchData(lastPunchId)
        .then((doc) => {
          let data = doc.data();
          if (data.status === "deleted") {
            setLastPunch(data.workerId)
              .then((doc) => {
                console.log("LastPunch change Completed...", doc);
              })
              .catch((err) => {
                console.log("error changing lastPunch status!", err);
              });
          }
          setLastPunchDetails(data);
          console.log("lastPunchDetails = ", data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  // using currentPunch to populate UI fields
  useEffect(() => {
    if (lastPunchId) {
      getPunchData(lastPunchId)
        .then((doc) => {
          let data = doc.data();
          if (data.status === "deleted") {
            setLastPunch(data.workerId)
              .then((doc) => {
                console.log("LastPunch change Completed...", doc);
              })
              .catch((err) => {
                console.log("error changing lastPunch status!", err);
              });
          }
          setLastPunchDetails(data);
          console.log(">>>> LS lastPunchDetails", data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [lastPunchId]);

  // for user who is recently registered and no lastPunch details
  useEffect(() => {
    // disable save  button as user need to provide input
    if (lastPunchDetails === undefined || lastPunchDetails === null) {
      setDisableSave(true);
    }

    // fetch Day from Start Date
    if (activityStartDate !== null && activityEndDate !== null) {
      let startDay = new Date(
        activityStartDate.getFullYear(),
        activityStartDate.getMonth(),
        activityStartDate.getDate()
      );

      // fetch Day from End Date
      let endDay = new Date(
        activityEndDate.getFullYear(),
        activityEndDate.getMonth(),
        activityEndDate.getDate()
      );

      // enable save button if user changes all inputs
      if (
        worker &&
        worker.workerId &&
        worker.workerId !== -1 &&
        isDateValid(activityStartTime) &&
        isDateValid(activityEndTime) &&
        isDateValid(activityStartDate) &&
        isDateValid(activityEndDate) &&
        !(activityStartDate < minForStartDate || activityStartDate > maxDate) &&
        !(endDay < startDay || activityEndDate > maxDate)
      ) {
        setDisableSave(false);
      } else {
        setDisableSave(true);
      }
    }
  }, [
    worker,
    activityStartDate,
    activityStartTime,
    activityEndDate,
    activityEndTime,
  ]);

  return (
    <AddEditPTOView
      lastPunch={lastPunchDetails}
      pageTitle={pageTitle}
      user={worker}
      back={back}
      activityStartDate={activityStartDate}
      activityStartTime={activityStartTime}
      activityStartDateChange={activityStartDateChange}
      activityStartTimeChange={activityStartTimeChange}
      activityEndDate={activityEndDate}
      activityEndTime={activityEndTime}
      activityEndDateChange={activityEndDateChange}
      activityEndTimeChange={activityEndTimeChange}
      cancelHandler={cancelHandler}
      saveHandler={saveHandler}
      confirmationMsg={confirmationMsg}
      closeModalConfirmationMsg={closeModalConfirmationMsg}
      confirmationMsgText={confirmationMsgText}
      confirmationTitleText={confirmationTitleText}
      allowNavigation={allowNavigation}
      disableSave={disableSave}
      workers={workers}
      employeeChange={employeeChange}
    />
  );
};

AddEditPTOContainer.propTypes = {};

export default AddEditPTOContainer;
